import { useRef } from 'react';
import { getStatusConfig } from '../utils';
import { StatusType } from '../types';
import { hideNotification, showNotification } from '@navi-toolbox/ui-components';
import { NotificationTemplates } from 'common/components/notification-template-factory/types';

type StatusClickHandler = (statusType: StatusType, statusId: string) => void;

export const useComparisonListStatus = () => {
  const clickHandlerRef = useRef<StatusClickHandler>();
  const config = getStatusConfig();
  return {
    showStatus: (statusType: StatusType) => {
      const data = config[statusType];
      if (data) {
        const statusId = showNotification({
          data: {
            ...data,
            onClick: () => {
              if (clickHandlerRef.current) {
                clickHandlerRef.current(statusType, statusId);
              }
            },
            onClose: () => hideNotification(statusId),
          },
          templateId: NotificationTemplates.Compare,
        });
      }
    },
    hideStatus: (id: string) => hideNotification(id),
    setClickHandler: (handler: StatusClickHandler) => {
      clickHandlerRef.current = handler;
    },
  };
};
